<template>
  <div class="scence">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
          <div class="selcountry">
            <span class="label">乡镇：</span>
            <el-select v-model="adcd" placeholder="请选择乡镇" clearable @change="thedata" filterable>
              <el-option v-for="item in adcdList" :key="item.adcd" :label="item.adnm" :value="item.adcd"></el-option>
            </el-select>
          </div>
          <span id="del" v-if="allowsPerm.delete" @click="delDialog"><span class="del-icon"></span>删除</span>
          <span id="edit" v-if="allowsPerm.update" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span id="add" v-if="allowsPerm.insert" @click="addDialog"><span class="add-icon"></span>新增</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table
              :data="tableData"
              v-loading="loading"
              row-key="adcd"
              border
              ref="multipleTable"
              lazy
              :load="load"
              :header-cell-style="{'text-align':'center'}"
              :max-height="height"
              :expand-row-keys="expandAdcd"
              @selection-change="handleSelectionChange"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column type="selection"  width="55" align="center"></el-table-column>
              <el-table-column prop="adnm" label="行政区划"></el-table-column>
              <el-table-column prop="adcd" label="政区代码" align="center"></el-table-column>
              <el-table-column prop="person" label="总人口" align="center"></el-table-column>
              <el-table-column prop="house" label="总户数" align="center"></el-table-column>
              <el-table-column prop="landArea" label="土地面积(平方公里)" align="center"></el-table-column>
              <el-table-column prop="cultiArea" label="耕地面积(亩)" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <el-dialog
      class="abow_dialog"
      :title="status + '乡镇'"
      :visible.sync="addbtn"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
        <el-form-item label="名称" prop="adnm">
          <el-input v-model="form.adnm"></el-input>
        </el-form-item>
        <!-- <el-form-item label="政区代码" prop="adcd" >
          <el-input v-model.number="form.adcd" type="number" @input="lenghtLimit" :readonly="status==='新增'?false:true"></el-input>
        </el-form-item> -->
        <el-form-item label="总人口" prop="person">
          <el-input v-model="form.population"></el-input>
        </el-form-item>
        <el-form-item label="总户数" prop="house">
          <el-input v-model="form.household"></el-input>
        </el-form-item>
        <el-form-item label="土地面积(平方公里)" prop="landArea">
          <el-input v-model="form.landArea"></el-input>
        </el-form-item>
        <el-form-item label="耕地面积(亩)" prop="cultiArea">
          <el-input v-model="form.cultiArea"></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="lng">
          <el-input v-model.number="form.lng" type="number"></el-input>
        </el-form-item>
        <el-form-item label="纬度" lng="lat">
          <el-input v-model.number="form.lat" type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
export default {
  data () {
    return {
      loading: true,
      height: document.documentElement.clientHeight - (document.documentElement.clientHeight * 0.2),
      screenHeight: document.documentElement.clientHeight, // 屏幕高度
      adcd: '',
      adcdList: [],
      expandAdcd: [],
      form: {
      },
      tableData: [],
      rules: {
        adnm: [
          { required: true, trigger: 'blur', message: '名称不会空' }
        ]
      },
      addbtn: false,
      pageIndex: '1',
      pageSize: '100',
      multipleSelection: [],
      status: '新增'
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  methods: {
    lenghtLimit () {
      let str = this.form.adcd + ''
      if (str.length > 15) {
        str = str.slice(0, 15)
      }
      this.form.adcd = Number(str)
    },
    computeHeight () {
      var ylHeight = this.screenHeight * 0.885
      this.$refs['skt'].style.height = ylHeight + 'px'
    },
    getAdcdList () {
      this.$store.dispatch(scenceTypes.getAdcd, {
        IsCounty: true,
        PageIndex: 1,
        PageSize: 1000
      }).then(data => {
        this.adcdList = data.results
      })
    },
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.getAdcdBaseInfo, {
        townAdcdCode: this.adcd
      }).then(async (data) => {
        this.tableData = data.rows
        if (data.rows.length > 0) {
          if (this.tableData[0].children) {
            for (let j = 0; j < this.tableData[0].children.length; j++) {
              this.$set(this.tableData[0].children[j], 'hasChildren', true)
            }
            this.expandAdcd.push(data.rows[0].adcd)
          }
        }
        this.loading = false
      })
    },
    async load (tree, treeNode, resolve) {
      let res = await this.$store.dispatch(scenceTypes.getAdcdBaseInfo, { townAdcdCode: tree.adcd })
      let data = []
      if (res.rows[0] && res.rows[0].children) {
        data = res.rows[0].children
        data.forEach(item => {
          item.hasChildren = true
        })
      }
      resolve(data)
    },
    handleClose (done) {
      this.$confirm('确认关闭？').then(_ => {
        done()
      }).catch(_ => {})
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 新增
    addDialog () {
      if (this.multipleSelection.length === 1) {
        let row = this.multipleSelection[0]
        this.status = '新增'
        this.form = {
          adcd: row.adcd
        }
        this.addbtn = true
      } else {
        this.$notify.info({ title: '提示', message: '请选择单条数据' })
      }
    },
    // 编辑
    editDialog () {
      if (this.multipleSelection.length === 1) {
        let row = this.multipleSelection[0]
        this.status = '编辑'
        row.population = row.person
        row.household = row.house
        row.adcd = Number(row.adcd)
        this.form = JSON.parse(JSON.stringify(row))
        this.addbtn = true
      } else {
        this.$notify.info({ title: '提示', message: '请选择单条数据' })
      }
    },
    // 删除
    delDialog () {
      let ids = []
      this.multipleSelection.forEach(item => {
        ids.push(item.id)
      })
      this.$confirm(`确定要删除选择的行政区 ?`, '确认').then(() => {
        this.$store.dispatch(scenceTypes.delAdcd, { id: ids.join(',') }).then(() => {
          this.$notify.success({ title: '成功', message: '删除数据成功.' })
          this.thedata()
        })
      }).catch(() => {})
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.$store.dispatch(scenceTypes.upAdcd, this.form).then(() => {
            this.addbtn = false
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.form = {}
          })
        }
      })
    }
  },
  mounted () {
    this.$store.dispatch('setAllowPerm', {
      name: this.$route.meta,
      type: this.$route.name
    })
    this.computeHeight()
    this.thedata()
    this.getAdcdList()
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style lang="less">
  .scence{
    .skt{
      margin-top: 5px !important;
      .select{
        padding-left: 15px;
        .selcountry{
          display: flex;
          width: auto;
          align-items: center;
          .label{
            margin-right: 10px;
          }
        }
      }
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }
  input[type="number"]{
      -moz-appearance: textfield;
  }
</style>
